const privacyPolicyBt = {
	breadcrumbs: { home: 'ཁྱིམ་', title: 'གསང་བ་སྲུང་བའི་སྲིད་དོན་' },
	hero: {
		title: 'གསང་བ་སྲུང་བའི་སྲིད་དོན་',
		subtitle: 'ཁྱེད་ཀྱི་རང་དབང་གནས་ཚུལ་དང་གསང་བ་སྲུང་བ་ང་ཚོའི་དམིགས་སྐལ་ཨིན།'
	},
	principles: [
		{ title: 'གནས་ཚུལ་བདེ་འཇགས་', description: 'རང་དབང་གནས་ཚུལ་དེ་སྤྱོད་ལམ་མཐུན་སྲུང་བའི་རིགས་ལྡན་' },
		{ title: 'མདྲོངས་པ་', description: 'ངས་ག་ཅི་འཐོབ་དང་ག་དེམ་ཚུལ་འཐོབ་བྱུས་གསལ་བཤད།' },
		{ title: 'ལག་དབང་', description: 'ཁྱེད་ཀྱི་གནས་ཚུལ་ལུ་ཁྱེད་ལས་ལག་དབང་ཡོད།' },
		{ title: 'གསང་བ་སྲུང་བ་', description: 'ཁྱེད་ཀྱི་གནང་བ་མ་ཐོབ་པར་ང་ཚོས་མ་སྤེལ།' }
	],
	dataTypes: [
		{ category: 'རང་དབང་གནས་ཚུལ་', items: ['མིང་', 'ཁ་པར་', 'ཨེ་མེལ་', 'སྐྱེས་ཚེས་'], purpose: 'ཁ་བྱང་གསརཔ་དང་དོ་དམ།' },
		{ category: 'ཁ་བྱང་གནས་ཚུལ་', items: ['ཁྱིམ་ཁ་བྱང་', 'གཏོང་ལེན་ཁ་བྱང་', 'ཡུལ་ཚོམ་', 'ལྷོད་ཁུལ་'], purpose: 'གཏོང་ལེན་དང་ཉེ་གནས་ཞབས་ཞུ་' },
		{ category: 'དངུལ་སྤྲོད་གནས་ཚུལ་', items: ['མོ་བཱེལ་བེང་ཀིང་', 'དངུལ་ཁང་རྩིས་', 'ཕན་ཚུན་ལམ་འགྲོའི་ལོ་རྒྱུས་'], purpose: 'དངུལ་སྤྲོད་མཐའ་བཙན་བཟོ་བ་' },
		{ category: 'སྤྱོད་ལམ་གནས་ཚུལ་', items: ['ཨེཔ་སྤྱོད་ལམ་ལོ་རྒྱུས་', 'འཚོལ་ཞིབ་', 'འདོན་ཐོ་'], purpose: 'རང་བཞིན་གནས་ཚུལ་སྤྱོད་ལམ་བཟོ་བ་' }
	],
	usage: {
		title: 'གནས་ཚུལ་སྤྱོད་ཚུལ་',
		primaryTitle: 'གཙོ་བོའི་སྤྱོད་ཚུལ་',
		primary: ['ཁ་བྱང་གསརཔ་དང་དོ་དམ།', 'གནང་བ་དང་གཏོང་ལེན་', 'མི་དམངས་ཞབས་ཞུ་', 'དངུལ་སྤྲོད་ལས་འགན་'],
		improveTitle: 'ལེགས་སྒྲུབ་དོན་ལུ',
		improve: ['རང་བཞིན་སེམས་ཁར་འོས་སྦྱོར་', 'ཞབས་ཞུ་སྤུས་ཚད་ལེགས་སྒྲུབ་', 'བདེ་འཇགས་དང་གྲངས་མིན་སྲུང་བ་', 'གོ་འཕེལ་དཔྱད་ཞིབ་']
	},
	rights: {
		title: 'ཁྱེད་ཀྱི་ཐོབ་དབང་',
		items: [
			{ right: 'འཚོལ་ཞིབ་ཐོབ་དབང་', description: 'ཁྱེད་ལུ་ང་ཚོས་སྲུངས་པའི་གནས་ཚུལ་ཤེས།' },
			{ right: 'ཞུན་དག་ཐོབ་དབང་', description: 'ནོར་འཁྲུལ་ཡང་ན་རྟག་མཐོང་གནས་ཚུལ་ཞུན་དག།' },
			{ right: 'བསུབས་ཐོབ་དབང་', description: 'རང་དབང་གནས་ཚུལ་བསུབས་དགོས་ཚེ།' },
			{ right: 'གནས་ཚུལ་འགྱེར་བཤུས་', description: 'ཁྱེད་ཀྱི་གནས་ཚུལ་ཅིག་ཡིག་སྣོད་ཕབ།' }
		]
	},
	security: {
		title: 'བདེ་འཇགས་ཐབས་ལམ་',
		intro: 'ཁྱེད་ཀྱི་གནས་ཚུལ་སྲུང་ནི་ལུ་ང་ཚོས་འོག་གི་ཐབས་ལམ་ལྟེམས།',
		measures: ['SSL གསང་སྡོམ་', 'དུས་མཐུན་བདེ་འཇགས་བཤེར་ཞིབ་', 'ལོ་རྒྱུས་གཉེར་བའི་བརྟེན་ཆས་', 'གནས་སྡུད་གྲབས་ཉར་དང་སོར་ཆུད་', 'འཛུལ་སྐབས་ཚད་འཛིན་', 'རབ་གནས་དུས་མཐུན་གསར་བསྒྱུར་']
	},
	cookies: {
		title: 'Cookies སྲིད་དོན་',
		usageTitle: 'Cookies སྤྱོད་ལམ་',
		p1: 'ང་ཚོས་ Cookies ལག་ལེན་འཐབ་ནས་བརྡ་འཚོལ་ཉམས་མྱོང་ལེགས་སྒྲུབ་དང་ ཞབས་ཞུ་རང་བཞིན་བཟོ་བ།',
		p2: 'ཁྱེད་ཀྱིས་བྱང་ཁའི་སྒྲིག་སྟངས་ནང་ Cookies ཚད་འཛིན་བྱེད་ཚུགས། མེད་པ་ཅན་བཟོས་ཚེ་ ཞབས་ཞུ་ཁ་ཤས་ལཱ་མི་འབད་བར་འགྱུར།'
	},
	sharing: {
		title: 'ཕྱིའི་ལས་ཚོགས་དང་སྤེལ་བ་',
		intro: 'ང་ཚོས་གཤམ་གྱི་གནས་ཚུལ་ལུ་ཕྱིའི་ལས་ཚོགས་དང་སྤེལ་བ་བྱེད།',
		authorizedTitle: 'ཆོག་འཐུས་སྤེལ་བ་',
		notDoTitle: 'ང་ཚོས་མི་བྱེད་པ་',
		authorized: ['གཏོང་ལེན་པ་ཚུ་ (ཁ་བྱང་གི་དོན་ལུ)', 'དངུལ་སྤྲོད་ལས་ཚོགས་ (ཕན་ཚུན་གྲངས་རྩིས་)', 'ཁྲིམས་ལྟར་དགོས་མཁོ་ (ཁྲིམས་ཁང་བཀའ་)'],
		notDo: ['སྤྱི་སྒེར་རྒྱུ་འབྲས་ལ་བཙོངས་', 'གནང་བ་མ་ཐོབ་པར་བརྡ་ལམ་ལྟར་སྤྱོད་', 'མཁོ་མེད་ཕྱིའི་ལས་ཚོགས་དང་སྤེལ་བ་']
	},
	retention: {
		title: 'གནས་སྡུད་ཉར་ཚགས་སྲིད་དོན་',
		retentionTitle: 'ཉར་ཚགས་དུས་ཡུན་',
		retentionText: 'ཁྱེད་ཀྱི་རང་དབང་གནས་ཚུལ་ ཁ་བྱང་ཤུགས་ལྡན་པའི་སྐབས་ཡང་ ཡང་ན་ཞབས་ཞུ་བྱེད་དགོས་པའི་ཚུལ་ལྟར་ཉར་ཚགས།',
		deleteTitle: 'བསུབས་',
		deleteText: 'ཁ་བྱང་ཁར་བཏོན་པའི་ཤུལ་མམ་ 30 ཉིན་ནང་རང་དབང་གནས་ཚུལ་ཆ་མཉམ་བསུབས། (ཁྲིམས་ལྟར་དགོས་མཁོ་མེད་པར)'
	},
	updates: {
		title: 'སྲིད་དོན་གསར་སྒྱུར་',
		alert: 'འདི་ད་ གསང་བ་སྲུང་བའི་སྲིད་དོན་གསར་སྒྱུར་འབད་བཏུབ།',
		notify: 'གནས་ཚུལ་སྒྱུར་སྟངས་ཡོད་པ་ཅིན་ ཨེ་མེལ་དང་ ཨེཔ་བརྡ་བསྐུལ་བྱེད། ཆེ་ཤོས་ཀྱི་སྒྱུར་སྟོན་ལུ་ཁྱེད་ལས་གནང་བ་འཐོབ་འོང་།',
		lastUpdatedPrefix: 'མཇུག་གསར་སྒྱུར་:',
		lastUpdatedDate: 'ཟླ་ 12 2023'
	},
	contact: {
		title: 'གསང་བ་སྲུང་བའི་འབྲེལ་ལམ་',
		subtitle: 'སྲིད་དོན་དང་རང་དབང་གནས་ཚུལ་སྐོར་ལས་དྲི་བ་ཡོད་པ་ཅིན་འབྲེལ་གནང་།',
		button: 'འབྲེལ་བ།',
		email: 'privacy@grameenbazar.com'
	}
};

export default privacyPolicyBt;


